// @ts-nocheck
import React from "react";
import { Button, Modal } from "antd";
import celebrationGif from '../../assets/congratulation.gif'
import celebrationSvg from '../../assets/celebration.svg'
import rotatingStars from '../../assets/rotatingStars.gif'
import '../css/congratulationModal.css'
const CongratulationModal = props => {
    const { rewardRecieved, setRewardRecieved } = props;
    return (
        <>
            <Modal
                footer={null}
                className="reward-celebration-modal"
                centered
                visible={rewardRecieved !== null}
                destroyOnClose={true}
                closable={false}
                maskClosable={true}
                onCancel={() => setRewardRecieved(null)}
            >
                <img className="celebration-svg" src={celebrationGif} alt="" />
                <div className="congratulation-text">Congratulations! <img src={celebrationSvg} alt="" /></div>
                <div className="points-recieved-for"> You've received your {rewardRecieved?.recievedFor} points!</div>
                <div className="points-earned"><img src={rotatingStars} alt="" />+{rewardRecieved?.pointsEarned} Points<img src={rotatingStars} alt="" /></div>
                <div className="earn-more-message">Keep earning points by completing activities,<br /> engaging with your team, and achieving your goals!</div>
                <Button className="congratulation-model-button" onClick={() => setRewardRecieved(null)}>Got It</Button>
            </Modal >
        </>
    )

}
export default CongratulationModal